import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeOrganizationsReqConfig = () => ({
  endpoint: 'paya',
  type: 'get',
  slug: ['organizations'],
});

const requestOptions = makeOrganizationsReqConfig();

export const consts = createReqConsts('payment-methods', 'organizations');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/payment-methods/requests/organizations-req.js